

export default function SustainablePracticesSection() {
  const practices = [
    {
      icon: 'ri-leaf-line',
      title: 'Responsible Materials',
      description: 'Use of eco-friendly tanning and dyeing processes, recycled fibers, and vegan alternatives such as PU and faux fur.',
      color: 'text-green-600'
    },
    {
      icon: 'ri-recycle-line',
      title: 'Energy & Waste Management',
      description: 'Commitment to reducing environmental impact through efficient resource use and waste reduction.',
      color: 'text-blue-600'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Long-Term Innovation',
      description: 'Developing sustainable leathers and outerwear fabrics to align with the future of fashion.',
      color: 'text-purple-600'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-light text-gray-900 leading-tight mb-6">
            Sustainable Practices
          </h2>
          <p className="text-lg text-gray-600 font-light max-w-3xl mx-auto">
            Every aspect of our manufacturing process is designed with sustainability in mind, from the materials we choose to the energy we consume.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {practices.map((practice, index) => (
            <div key={index} className="bg-white p-8 transition-shadow duration-300">
              <div className="text-center space-y-6">
                <div className={`w-16 h-16 ${practice.color} mx-auto flex items-center justify-center rounded-full bg-gray-50`}>
                  <i className={`${practice.icon} text-2xl`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-medium text-gray-900 mb-4">
                    {practice.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed font-light">
                    {practice.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
